import { Map as MlMap, ExpressionSpecification } from "maplibre-gl";

export const obstacleImageExpression: ExpressionSpecification = [
  "case",
  ["==", ["slice", ["downcase", ["coalesce", ["get", "src"], ""]], -8], "_lighted"],
  "obstacle-lighted",
  "obstacle-standard",
];

/** `icon-size` of the obstacle icon. The 3D point sprites use the same size. */
export const OBSTACLE_MIN_ZOOM = 13;

export const OBSTACLE_ICON_SIZE = 1.12;

/** True when the feature `src` marks a lighted obstacle; same rule as `obstacleImageExpression`. */
export function isLightedObstacleSrc(src: unknown): boolean {
  return String(src ?? "")
    .toLowerCase()
    .endsWith("_lighted");
}

/** Aeronautical obstacle silhouettes; never infer lighting from the structure type. */
export function addObstacleImages(map: MlMap): void {
  for (const lighted of [false, true]) {
    const id = lighted ? "obstacle-lighted" : "obstacle-standard";
    if (map.hasImage(id)) continue;
    map.addImage(id, drawObstacleIcon(lighted), { pixelRatio: 2 });
  }
}

/** 64 x 64 obstacle icon, drawn at pixel ratio 2. Also the texture of the 3D point sprites. */
export function drawObstacleIcon(lighted: boolean): ImageData {
  const canvas = document.createElement("canvas");
  canvas.width = canvas.height = 64;
  const ctx = canvas.getContext("2d")!;
  ctx.lineJoin = "round";
  ctx.lineCap = "round";
  // Tapered obstacle with a circular foot, anchored at the geographic point.
  // A thin black casing keeps the red symbol legible over map backgrounds.
  for (const [color, width] of [
    ["#000000", 6],
    ["#d40000", 4],
  ] as const) {
    ctx.strokeStyle = color;
    ctx.lineWidth = width;
    ctx.beginPath();
    ctx.moveTo(14, 57);
    ctx.lineTo(32, 19);
    ctx.lineTo(50, 57);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(32, 51, 6, 0, Math.PI * 2);
    ctx.stroke();
    if (lighted) {
      for (const angle of [-150, -120, -90, -60, -30]) {
        const a = (angle * Math.PI) / 180;
        ctx.beginPath();
        ctx.moveTo(32 + Math.cos(a) * 10, 19 + Math.sin(a) * 10);
        ctx.lineTo(32 + Math.cos(a) * 16, 19 + Math.sin(a) * 16);
        ctx.stroke();
      }
    }
  }
  return ctx.getImageData(0, 0, 64, 64);
}
